import React, { useState } from "react";
import { ShieldCheck, Truck, Star, Flame, Gem, Sparkles, Trophy, Heart } from "lucide-react";

// Reusable badge registry — to add a badge later, add it here and in backend badges.py.
export const BADGE_DEFS = {
  verified: {
    label: "JohnnyMart Verified",
    Icon: ShieldCheck,
    cls: "bg-teal-700 text-white",
    tooltip: "This item has completed our internal quality review. Product details, pricing, photos, shipping information, and inventory have all been verified before listing.",
  },
  free_shipping: {
    label: "Ships Free",
    Icon: Truck,
    cls: "bg-green-700 text-white",
    tooltip: "This item ships free — no shipping charge added at checkout.",
  },
  staff_pick: { label: "Staff Pick", Icon: Star, cls: "bg-gold text-navy", tooltip: "Hand-picked by the JohnnyMart team." },
  hot_item: { label: "Hot Item", Icon: Flame, cls: "bg-brick text-white", tooltip: "One of the most popular items in the shop right now." },
  rare_find: { label: "Rare Find", Icon: Gem, cls: "bg-purple-700 text-white", tooltip: "A hard-to-find treasure — once it's gone, it's gone." },
  just_listed: { label: "Just Listed", Icon: Sparkles, cls: "bg-navy text-cream", tooltip: "Fresh in the shop — recently added to our inventory." },
  top_seller: { label: "Top Seller", Icon: Trophy, cls: "bg-amber-600 text-white", tooltip: "One of JohnnyMart's best-selling items." },
  customer_favorite: { label: "Customer Favorite", Icon: Heart, cls: "bg-rose-600 text-white", tooltip: "Loved by JohnnyMart customers." },
};

export const ProductBadge = ({ badge, slug, size = "sm" }) => {
  const def = BADGE_DEFS[badge];
  const [open, setOpen] = useState(false);
  const timer = React.useRef(null);
  if (!def) return null;
  const { Icon } = def;
  const sz = size === "lg" ? "text-xs px-3 py-1.5" : "text-[10px] px-2.5 py-1";
  const show = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setOpen(true);
    clearTimeout(timer.current);
    timer.current = setTimeout(() => setOpen(false), 3500);
  };
  return (
    <span className="relative inline-flex">
      <button
        type="button"
        data-testid={`badge-${badge}${slug ? `-${slug}` : ""}`}
        onClick={show}
        onMouseEnter={() => setOpen(true)}
        onMouseLeave={() => { clearTimeout(timer.current); setOpen(false); }}
        className={`inline-flex items-center gap-1 font-bold uppercase tracking-wide rounded-full ${sz} ${def.cls}`}
      >
        <Icon className={size === "lg" ? "w-3.5 h-3.5" : "w-3 h-3"} /> {def.label}
      </button>
      {open && (
        <span
          data-testid={`badge-tooltip-${badge}`}
          className="absolute bottom-full left-0 mb-2 z-40 w-60 rounded-md bg-navy text-cream text-xs leading-relaxed p-3 shadow-xl normal-case font-normal tracking-normal text-left"
        >
          <b className="block mb-1">{def.label}</b>
          {def.tooltip}
          <span className="absolute top-full left-6 border-8 border-transparent border-t-navy" />
        </span>
      )}
    </span>
  );
};

export const ProductBadges = ({ badges, slug, size }) => {
  if (!badges || badges.length === 0) return null;
  return (
    <span className="inline-flex flex-wrap gap-1.5" data-testid={`badges-${slug || "row"}`}>
      {badges.map((b) => <ProductBadge key={b} badge={b} slug={slug} size={size} />)}
    </span>
  );
};
